import React, {useState, useEffect} from "react";

interface CookieConsentBannerProps {
  location?: "bottom" | "top";
  buttonText?: string;
  cookieName?: string;
  style?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  expires?: number;
  children?: React.ReactNode;
}

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({
  location = "bottom",
  buttonText = "Accept",
  cookieName = "CookieConsent",
  style = {},
  buttonStyle = {},
  expires = 365,
  children
}) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if consent has already been given
    const consentGiven = getCookie(cookieName);
    if (!consentGiven) {
      setShowBanner(true);
    }
  }, [cookieName]);

  const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(";").shift() || null;
    }
    return null;
  };

  const setCookie = (name: string, value: string, days: number) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const handleAccept = () => {
    setCookie(cookieName, "true", expires);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  const defaultStyle: React.CSSProperties = {
    position: "fixed",
    left: 0,
    right: 0,
    zIndex: 9999,
    padding: "20px",
    backgroundColor: "#fc6719",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "15px",
    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
    ...(location === "bottom" ? {bottom: 0} : {top: 0}),
    ...style
  };

  const defaultButtonStyle: React.CSSProperties = {
    backgroundColor: "white",
    color: "#000",
    border: "none",
    padding: "8px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "bold",
    minWidth: "80px",
    ...buttonStyle
  };

  const messageStyle: React.CSSProperties = {
    flex: 1,
    marginRight: "15px",
    fontSize: "14px",
    lineHeight: "1.4"
  };

  return (
    <div style={defaultStyle}>
      <div style={messageStyle}>
        {children ||
          "This site uses cookies. By continuing to browse the site, you are agreeing to our use of cookies."}
      </div>
      <button
        style={defaultButtonStyle}
        onClick={handleAccept}
        onMouseOver={(e) => {
          e.currentTarget.style.opacity = "0.9";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.opacity = "1";
        }}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default CookieConsentBanner;
